import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import router from '@/router'
import { useUiStore } from '@/stores/ui'
import { registerServiceWorker } from '@/lib/push'
import '@/styles/application.css'

// El guard del router carga la sesión (/api/me) antes de resolver la primera ruta,
// así que basta con montar la app.
const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)

// Aplica el tema (claro/oscuro) guardado antes de montar, para evitar el parpadeo.
useUiStore(pinia).initTheme()

app.mount('#app')

// Registra el service worker (necesario para las notificaciones push).
registerServiceWorker()

// El service worker nos pide navegar al tocar una notificación (deep link).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'navigate' && event.data.url) {
      router.push(event.data.url)
    }
  })
}
